"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = void 0;
class ValidationError extends Error {
    constructor(name, message) {
        super(message);
        this.className = "ValidationError";
        this.name = "";
        this.message = "";
        this.name = name;
        this.message = message;
    }
}
exports.ValidationError = ValidationError;
//# sourceMappingURL=ValidationError.js.map